import script from "./VectorStore.vue?vue&type=script&setup=true&lang=js"
export * from "./VectorStore.vue?vue&type=script&setup=true&lang=js"

import "./VectorStore.vue?vue&type=style&index=0&id=6f172e46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f172e46"]])

export default __exports__